/* These are designed to be spread into input props. Validators that require
a value are functions that return an object */

import {DateTime} from "luxon";

const isNull = val => {
    let sanitized = val;
    if (typeof val === 'string') sanitized = val.replace(" ", "")
    return [null, undefined, ''].includes(sanitized);
}

const validators = {


    exists: {
        errorText: 'Required',
        validator: val => !!(val || val === 0),
    },

    isEmail: {
        errorText: 'This is not a valid email',
        validator: val => {
            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(val).toLowerCase());
        }
    },

    isEmailOrNull: {
        errorText: 'This is not a valid email',
        validator: val => {
            // eslint-disable-next-line
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return isNull(val) || val === '' || re.test(String(val).toLowerCase());
        }
    },

    isPhoneNumber: {
        errorText: 'This is not a valid phone number',
        validator: val => {
            return isNull(val) || ((val.match(/\d/g) || []).length === 10);
        }
    },

    isPhoneNumberNotNull: {
        errorText: 'This is not a valid phone number',
        validator: val => {
            if (!val) return false;
            return ((val.match(/\d/g) || []).length === 10);
        }
    },


    isNumberNotNull: {
        errorText: 'Must be a number.',
        validator: val => {
            if (!val) return false;
            return (!isNaN(parseFloat(val)) && isFinite(val));
        }
    },

    isNumber: {
        errorText: 'Must be a number.',
        validator: val => {
            return (!isNaN(parseFloat(val)) && isFinite(val)) || isNull(val);
        }
    },

    isNumberWhenStripped: {
        errorText: 'Must be a number.',
        validator: val => {
            val = val.replace(/[^0-9.]/g, '');
            return (!isNaN(parseFloat(val)) && isFinite(val)) || isNull(val);
        }
    },

    isStringOfMinLength: (len = 2) => ({
        errorText: "Cannot be less than " + len + " characters",
        validator: val => {
            return  (typeof val === 'string' && val.length >= len)
        }
    }),

    isStringOfMaxLength: (len = 255) => ({
        errorText: "Cannot be longer than " + len + " characters",
        validator: val => {
            return  (typeof val === 'string' && val.length <= len)
        }
    }),

    isBool: {
        errorText: 'Must be true or false',
        validator: val => {
            return typeof val === 'boolean'
        }
    },

    isOKPassword: {
        errorText: 'Password must be at least 6 characters long, with at least one upper case, one lower case, and one digit.',
        validator: val => {
            const regexp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{6,}$/;
            return (
                typeof val === 'string' &&
                regexp.test(val)
            )
        }
    },

    isValidFormattedDate: fromdateformat => ({
        errorText: 'That was not a valid date. Please enter in format ' + fromdateformat,
        validator: (val, fromdateformat) => {
            return {
                formatter: (val) => {
                    if (!val) return false;
                    let input = val.replace(/\D/g, '');
                    let dt = DateTime.fromFormat(input, fromdateformat)
                    return dt.isValid
                }
            }
        }
    }),

    isValidHex: {
        errorText: 'That was not a valid hex code. They must start with a #, and contain exactly six characters 1-9 A-f',
        validator: val => /^#([0-9A-F]{3}){1,2}$/i.test(val)
    },

    isValidSlug: {
        errorText: "That was not a valid slug. Slugs may have only lowercase a-z and hyphens.",
        validator: val =>  /^[a-z\-]*$/.test(val)
    }

}

export default validators;
